import {NavBar} from './NavBar';
import RenderTopologies from './RenderTopologies';
import "./Treatment.scss";

export const Treatments = () => {

  return (
    <div className="treatment">
      <div className="toolbar">
        {/* call api get topologies */}
        <NavBar />
      </div>
      <div className="m-2 p-3">
        {/* component who list the topologies with filter and pagination */}
        <RenderTopologies />
      </div>
    </div>
  );
};
